import { InputText } from '@telavita-core/react-design-kit'
import { CoreIcons } from 'components'
import { MedicalAppointmentFormData } from 'components/MedicalRequestForm/schema'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import * as S from '../../styles'

export const DocumentFileInput = () => {
  const { control } = useFormContext<MedicalAppointmentFormData>()

  return (
    <Controller
      control={control}
      name="documentFile"
      render={({
        field: { onChange, value, ...field },
        fieldState: { error },
      }) => (
        <InputText
          {...field}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            onChange(e.target.files ?? undefined)
          }}
          endIcon={
            <S.WrapperIcon>
              <CoreIcons name="Clip" fill="#9F9F9F" height="24px" width="24px" />
            </S.WrapperIcon>
          }
          floatingLabel="Anexar pedido médico"
          handleClearSearchField={() => onChange(undefined)}
          type="file"
          accept=".pdf,.jpg,.jpeg,.png"
          hasError={Boolean(error?.message)}
          helperMessage={error?.message ?? 'O pedido médico é obrigatório. Caso não possua, procure um médico e obtenha o encaminhamento.'}
          helperMessageVariant={error?.message ? 'error' : 'default'}
        />
      )}
    />
  )
}
